import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function CTASection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="relative py-24 px-4 md:px-8 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #8B1428 0%, #C41E3A 40%, #8B1428 100%)' }}
    >
      {/* Background image overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cattle%20livestock%20silhouette%20herd%20at%20sunset%20dark%20moody%20atmospheric%20dramatic%20sky%20wide%20panoramic%20cinematic%20golden%20red%20tones&width=1920&height=600&seq=cta1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top opacity-15"
        />
      </div>

      {/* Noise */}
      <div
        className="absolute inset-0 pointer-events-none opacity-10"
        style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.85\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\' opacity=\'0.15\'/%3E%3C/svg%3E")' }}
      />

      {/* Glow blobs */}
      <div className="absolute left-1/4 top-0 w-72 h-72 bg-white/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute right-1/4 bottom-0 w-72 h-72 bg-dark/20 rounded-full blur-3xl pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className={`reveal ${isVisible ? 'visible' : ''}`}>
          <p className="text-white/60 text-xs font-semibold tracking-[3px] uppercase mb-4">
            Ready to Grow?
          </p>
          <h2 className="font-poppins font-bold text-3xl md:text-5xl text-white leading-tight mb-6">
            Help Your Livestock Thrive<br className="hidden md:block" /> with Hamva
          </h2>
          <p className="text-white/70 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
            Get in touch with our experts via WhatsApp for product recommendations, pricing, and distribution inquiries.
          </p>
          <a
            href="https://wa.me/923007321011"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 rounded-full bg-white text-accent font-poppins font-bold text-base cursor-pointer whitespace-nowrap hover:bg-white/90 transition-all duration-300 hover:scale-105 hover:shadow-2xl"
          >
            <i className="ri-whatsapp-line text-xl" />
            WhatsApp Us Now
          </a>
        </div>
      </div>
    </section>
  );
}
